export const getRefs = <T extends Record<string, HTMLElement> = Record<string, HTMLElement>>(rootEl: HTMLElement) => {
  const refs = rootEl.querySelectorAll<HTMLElement>("[h-ref]");
  const refsObj: Record<string, HTMLElement> = {};

  for (const ref of refs) {
    const refName = ref.getAttribute("h-ref");

    if (!refName) continue;
    refsObj[refName] = ref;
  }

  return refsObj as T;
};

export const updateElement = (target: HTMLElement, source: HTMLElement) => {
  target.innerHTML = source.innerHTML;
  target.className = source.className;

  for (const { name } of target.attributes) {
    if (name === "class") continue;

    target.removeAttribute(name);
  }

  for (const { name, value } of source.attributes) {
    target.setAttribute(name, value);
  }
};

/**
 * A function to update the children of an element without needing to recreate them.
 *
 * @param target The target element
 * @param source The source elements
 */
export const updateChildren = (target: HTMLElement, source: HTMLElement[]) => {
  const targetChildren = target.children;
  const sourceChildren = source;

  for (let i = 0; i < sourceChildren.length || i < targetChildren.length; i++) {
    const sourceChild = sourceChildren[i];
    const targetChild = targetChildren[i];

    if (!targetChild) {
      if (sourceChild) {
        target.append(sourceChild);
      }
      continue;
    }

    if (!sourceChild) {
      target.removeChild(targetChild);
      continue;
    }

    if (sourceChild.isEqualNode(targetChild)) continue;

    if (sourceChild.tagName !== targetChild.tagName) {
      target.replaceChild(sourceChild, targetChild);
      continue;
    }

    updateElement(targetChild as HTMLElement, sourceChild as HTMLElement);
  }
};
